/* Number ops */

import Storage from "./storage.service";
import Helpers from "../helpers/shared.helper";
import Products from "./products.service";

var Promotions = {};

Promotions.setPromotions = (data, productCode) => {
	let productPromotions = Storage.get("productPromotions");
	if (!productPromotions) {
		productPromotions = {};
	}
	productPromotions[productCode] = data;
	Storage.set("productPromotions", productPromotions);
};

Promotions.getPromotionsByPlan = plan => {
	if (plan["Promotions"]) {
		return plan["Promotions"];
	} else {
		if (plan["promotions"]) {
			return plan["promotions"];
		} 
		// else {
		// 	return Promotions.getPromotionsByKeys(plan["PromotionKeys"]);
		// }
	}
	return [];
};

Promotions.getPromotionsByKeys = keys => {
	let product = Products.getCurrentProduct();
	let code = product.ProductCode;
	return Storage.get("productPromotions")[code].filter(item => {
		return keys.indexOf(item.Key) !== -1;
	});
};

Promotions.includesUserPromo = promotions => {
	let result = false;
	if (promotions) {
		for (let promotion of promotions) {
			if (promotion.IsUserPromo) {
				result = true;
				break;
			}
		}
	}
	return result;
};

Promotions.combinePromotions = (saved_promotions, plan_promotions) => {
	let all_promotions = [];

	let ids = [];

	for (let promo of plan_promotions) {
		ids.push(promo.ID);
		all_promotions.push(promo);
	}

	if (saved_promotions) {
		for (let promo of saved_promotions) {
			if (promo.IsUserPromo && ids.indexOf(promo.ID) === -1) {
				all_promotions.push(promo);
			}
		}
	}

	return all_promotions;
};

Promotions.calculateAllPromotions = (promotions, originalPlan = null) => {
	let promo = {};

	promo["extraData"] = 0;
	promo["extraLocal"] = 0;
	promo["extraInternational"] = 0;

	promo["addons"] = [];

	let found_deduction_promo = false;

	for (let promotion of promotions) {
		let type = promotion.Category;

		if (
			!found_deduction_promo &&
			originalPlan &&
			originalPlan["PackagePrice"]
		) {
			if (type === "AmountDiscount" || type === "PercentageDiscount") {
				found_deduction_promo = true;
			}
		}

		//if (type === "ZeroAmount") {
		// do nothing
		//}

		if (type === "AddOn") {
			promo["addons"].push(promotion.Type);
		}

		if (type === "RecurringData" || type === "MGM") {
			promo["extraData"] += promotion.Value;
		}

		if (promotion.Plan) {
			if (promotion.Plan.Type === "DATA") {
				promo["extraData"] += promotion.Plan["Value"];
			}
			if (promotion.Plan.Type === "VOICE-LCL") {
				promo["extraLocal"] += promotion.Plan["Value"];
			}
			if (promotion.Plan.Type === "VOICE-INT") {
				promo["extraInternational"] += promotion.Plan["Value"];
			}
		}
	}

	promo["extraDataFormatted"] = Helpers.bytesToGBs(promo["extraData"]);
	promo["extraLocalFormatted"] = Helpers.milisecondstoMinutes(
		promo["extraLocal"]
	);
	promo["extraInternationalFormatted"] = Helpers.milisecondstoMinutes(
		promo["extraInternational"]
	);

	return promo;
};

export default Promotions;
